import { getBillingPartyString } from '../../../../containers/AppPage/Sales/helper';
import { Type } from '../../../../redux/Transaction/helper';
import { TableName } from '../../../../redux/EditableTable/options';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import ListActions from '../../../../redux/List/actions';
import TransactionActions from '../../../../redux/Transaction/actions';
import EditableActions from '../../../../redux/EditableTable/actions';
import ContactActions from '../../../../redux/Contact/actions';
import { SubscriptionCheck } from '../../../Access/helper/subscription/SubscriptionCheck';
import { SubscriptionScopeKey } from '../../../Access/helper/subscription/enum/SubscriptionScopeKey';
import { useEffectChange } from '../../helpers/useCompare';
import { useCallback } from 'react';
import {usePrevious} from "../../../../helpers/useReadStateSuccess";
import _ from 'underscore';
import {Helper} from 'bukku/containers/AppPage/Sales/Invoices/helper';
import { getShowMyInvoisActionButton } from '../../../../containers/AppPage/MyInvois/helper/getShowMyInvoisActionButton';
import dayjs from 'dayjs';

const {
    addContact,
    replaceContactPersons,
} = ListActions;

const {
    changeContactId,
    setShowShipping,
    setEmails,
    setTermId,
    transactionChangeMyinvoisAction,
} = TransactionActions;

const {
    setItems,
} = EditableActions;

const {
    setBillingContactPersonId,
    setShippingContactPersonId,
} = ContactActions;

const selectorFn = state => ({
    contactId: state.Transaction.contactId,
    paymentMode: state.Transaction.paymentMode,
    transactionInitState: state.Transaction.transactionInitState,
    transactionReadState: state.Transaction.transactionReadState,
    contacts: state.List.contacts,
    contactPersons: state.List.contactPersons,
    transaction: state.Transaction.transaction,
    showShipping: state.Transaction.showShipping,
    terms: state.List.terms,
    date: state.Transaction.date,
    transactionStatus: state.Transaction.transactionStatus,
    instructionTransactionStatus: state.Instruction.transactionStatus,
    isMyInvoisEnabled: state.List.settings?.is_myinvois_submission_enabled,
    myInvoisStartDate: state.List.settings?.myinvois_start_date,
});

export function useContact(
    { isRecurring, form, specs, transactionType, isMalaysianCompany },
    readAddresses, currencyCodeChanged, readContactPersons,
) {
    const dispatch = useDispatch();
    const subscription = {
        currency: SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo(),
        tag: SubscriptionCheck.withKeys(SubscriptionScopeKey.TAG).hasSubscriptionTo(),
    };
    // Redux
    const {
        contactId,
        paymentMode,
        transactionInitState,
        transactionReadState,
        contacts,
        terms,
        date,
        transactionStatus,
        instructionTransactionStatus,
        isMyInvoisEnabled,
        myInvoisStartDate,
    } = useSelector(selectorFn, shallowEqual);

    const contactIdChanged = useCallback(value => {
        // Recurring Instructions
        // - field: contact_and_group_id
        // - User can select Contact Group or Contact
        let contactId = value;
        if (isRecurring && typeof value === 'string') {
            contactId =
                value.includes('contact_') ?
                    parseInt(value?.toString().replace(/^contact_/, ""), 10) :
                    null;
        }

        if (!contactId) {
            if (specs.contactPersons) {
                // reset cp list and billing/shipping cp id on contact clear
                dispatch(replaceContactPersons([]));
                dispatch(setBillingContactPersonId(null));
                dispatch(setShippingContactPersonId(null));
            }
            return null;
        }

        const contact = contacts.find(contact => contact.id === contactId);

        if (!contact)
            return null;

        // Update Currency Code
        if (contact.default_currency_code && subscription.currency)
            currencyCodeChanged(contact.default_currency_code, true);

        // Read Contact Addresses:
        // - Set bypassReadListState is true
        // - to avoid invoking initForm again (at create.js / view.js).
        if (!isRecurring)
            readAddresses(contactId);

        // Read Contact Persons (CP for both form and redux store will be updated in useContactPersons.js)
        readContactPersons(contactId);

        // Update Billing Party, Shipping Party
        const formData = {
            billing_party: !isRecurring ? getBillingPartyString(contact) : null,
        };

        if (!specs.companyAddresses && !isRecurring)
            formData.shipping_party = contact.shipping_party ? contact.shipping_party : null;

        // Update Tag Ids
        if (specs.tags)
            formData.tag_ids = subscription.tag ? contact?.tag_ids : undefined;

        // Update Emails
        if (specs.emails && !isRecurring) {
            dispatch(
                setEmails(contact.email),
            );
        }

        // Update Show Shipping
        if (!specs.companyAddresses && specs.showShipping) {
            dispatch(
                setShowShipping(!!(contact.shipping_party ||
                    contact.shipping_first_name || contact.shipping_last_name)),
            );
        }

        console.log('aaa contactIdChange', {
            contactId,
            contact,
            formData,
            paymentMode,
        });

        // Update Term Id
        if (contact.default_term_id) {
            // DO, Bill
            if (
                transactionType === Type.sale_delivery_order
                // transactionType === Type.sale_order ||
            ) {
                dispatch(
                    setTermId(contact.default_term_id),
                );
                formData.term_id = contact.default_term_id;
            }
            // Quotations / Invoice / Bill
            else if (
                transactionType === Type.sale_quote ||
                transactionType === Type.sale_order ||

                transactionType === Type.sale_invoice ||
                (transactionType === Type.purchase_bill && paymentMode !== 'cash') ||
                transactionType === Type.purchase_order
            ) {
                const term = _.findWhere(terms, {id: contact.default_term_id});

                // Update term item (if only 1 term item)
                dispatch(
                    setItems(
                        TableName.payment_term,
                        [{
                            term_id: contact.default_term_id,
                            date: Helper.calcDueDateByTerm(term, date),
                            payment_due: '100%',
                            is_recurring: false,
                        }],
                    ),
                );
            }
        }

        const parsedStatus = !isRecurring ? transactionStatus : instructionTransactionStatus;
        const showMyInvoisActionButton = getShowMyInvoisActionButton(
            isMalaysianCompany,
            transactionType,
            parsedStatus,
            isRecurring,
        );

        if (showMyInvoisActionButton && contact.default_myinvois_action) {
            const isTransactionBeforeMyInvoisStartDate = isMyInvoisEnabled && myInvoisStartDate
                ? dayjs(date).isBefore(dayjs(myInvoisStartDate), "day")
                : false;

            if (!isTransactionBeforeMyInvoisStartDate) {
                dispatch(transactionChangeMyinvoisAction(contact.default_myinvois_action));
                formData.myinvois_action = contact.default_myinvois_action;
            }
        }

        // Update Form
        return form.setFieldsValue(formData);
    }, [
        contacts,
        currencyCodeChanged,
        dispatch,
        form,
        isRecurring,
        paymentMode,
        readAddresses,
        readContactPersons,
        specs.emails,
        specs.showShipping,
        specs.tags,
        specs.companyAddresses,
        subscription.currency,
        subscription.tag,
        transactionType,
        date,
        terms,
        specs.contactPersons,
        isMalaysianCompany,
        transactionStatus,
        instructionTransactionStatus,
        isMyInvoisEnabled,
        myInvoisStartDate,
    ]);

    const prevTransactionReadState = usePrevious(transactionReadState);
    const prevTransactionInitState = usePrevious(transactionInitState);

    useEffectChange(contactId, (prevContactId, contactId) => {
        if (
            prevTransactionReadState === transactionReadState &&
            prevTransactionInitState === transactionInitState
        )
            contactIdChanged(contactId, true);
    });

    const onContactIdChange = useCallback((id, updateForm = false) => {
        dispatch(
            changeContactId(id),
        );

        if (updateForm)
            form.setFieldsValue({contact_id: id});
    }, [dispatch, form]);

    const onContactCreate = useCallback(response => {
        dispatch(
            addContact(response),
        );
        onContactIdChange(response.id, true);
    }, [dispatch, onContactIdChange]);

    const onContactUpdate = useCallback(() => {}, []);

    return {
        onContactIdChange,
        onContactCreate,
        onContactUpdate,
    };
}
